import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RegistrationService } from "../Services/registration.service";

@Injectable()
export class CanActivateRegistrationSuccess  {
    constructor(
        private router: Router,
        private registrationService: RegistrationService
        ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (this.registrationService.registered) {
            return true
        } else {
            return this.router.createUrlTree(environment.startRoute)
        }
    }
}